/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Button, Col } from 'reactstrap';
import { FlexboxGrid, Form, FormGroup } from 'rsuite';
import { addGroupID, addMenuID } from '~/store/modules/Grupos/actions';
import Checks from './Form/Checks';
import SelectGrupo from './Form/SelectGrupo';
import SelectMenu from './Form/SelectMenu';
import SubMenuGrid from './SubMenuGrid';

function PermissaoForm({ setForm, form }) {
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  function handleFormChange(value) {
    setForm({ ...form, ...value });
  }
  function handleSubmit() {}
  return (
    <Form
      formValue={form}
      onChange={handleFormChange}
      onSubmit={(e) => handleSubmit(e)}
      fluid
      style={{ width: '100%' }}
      className="pageForm"
    >
      <FormGroup className="pageFormContainer" style={{ display: 'block' }}>
        <SelectGrupo setForm={setForm} form={form} />
        <Checks setForm={setForm} form={form} />
        <SelectMenu setForm={setForm} form={form} />
        <FlexboxGrid align="top" style={{ margin: '16px 0' }}>
          <FlexboxGrid.Item
            componentClass={Col}
            colspan={24}
            md={12}
            style={{ padding: '0 8px' }}
          >
            <Button
              color="primary"
              onClick={async () => {
                setIsSelected(false);
                await dispatch(addGroupID(form.idGrupo));
                await dispatch(addMenuID(form.idMenu));
                setIsSelected(true);
              }}
              size="sm"
              disabled={!form.idMenu}
            >
              <FaSearch /> Buscar Sub Menus
            </Button>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        {isSelected ? (
          <SubMenuGrid setLoading={setLoading} loading={loading} form={form} />
        ) : (
          ''
        )}
      </FormGroup>
    </Form>
  );
}

export default PermissaoForm;
